import { h, Fragment } from 'preact';
import { Link } from 'preact-router/match';
import { useEffect } from 'preact/hooks';

import { useSignal, useSignalEffect } from '@preact/signals';

import { route } from 'preact-router';
import { ReviewState } from '../../states/kyc-review-state';
import CustomHeight from '../height/custom-height';
import { confirmInformations } from '../../controllers/UserApiControler';
import { GlobalState } from '../../states/global-state';
import AlertMessages from '../../constants/alert';

const ReviewTab = props => {
  const isReview = useSignal(false);

  useSignalEffect(() => {
    const completeness = GlobalState.completeness.value;
    if (Object.keys(completeness).length) {
      if (!completeness.isComplete) {
        route('/kyc', true);
      }
    }
  });

  useEffect(() => {
    if (props.path && props.path.includes && props.path.includes('review')) {
      isReview.value = true;
    }
  }, []);

  const confirmHandler = async () => {
    // console.log('confirm');

    const response = await confirmInformations();
    if (response.code == 1) {
      GlobalState.set.showModal(true, {
        text: AlertMessages.confirmInformations,
        showNegativeBtn: false,
        positiveCallback: () => {
          // console.log('here');
          // route('/kyc');
          route('/redirect/dashboard');
          console.log('should redirect to dashboard');
          //TODO - redirect to dashboard
        },
      });
    }
  };

  return (
    <>
      <nav class="nav nav-underline flex-column flex-sm-row">
        <li class="nav-item">
          <Link class="nav-link" href="/profile">
            PROFILE
          </Link>
        </li>

        <li class="nav-item">
          <Link
            class={`nav-link ${isReview.value ? 'active' : ''}`}
            activeClassName="active"
            href="/review"
          >
            REVIEW
          </Link>
        </li>
      </nav>
      <CustomHeight height="24px" />

      <div class="hstack gap-3 bg-black bg-gradient p-3">
        <div class=" me-auto" />
        <button
          class={`btn btn-${
            ReviewState.isEditing.value ? 'success' : 'warning'
          }`}
          onClick={() =>
            (ReviewState.isEditing.value = !ReviewState.isEditing.value)
          }
        >
          {ReviewState.isEditing.value ? 'Review' : 'Edit'}
        </button>
        <button class={`btn btn-success`} onClick={confirmHandler}>
          Confirm and Submit
        </button>
      </div>
    </>
  );
};

export default ReviewTab;
